import { authGet } from './authCalls';

export const serviceAuth = async () => {
    return authGet('/api/auth/userinfo');
}